module.exports = __webpack_public_path__ + "60fecaa4a53a2c7da7fb9c55b1563964.gif";